export default "__VITE_ASSET__BCWZzcVN__"